const APP_CONFIG = {
    // Tytuł strony
    MAIN_PAGE_TITLE: 'Czysta Polska',

    // Parametr `portal` użyty w UserAgentData
    UAD_PORTAL: 'czystapolskaapp',

    // Stary format user agenta, przykład: `www_iplatv/12345`
    // Parametr `ua` nie będzie wysyłany, jeśli wartością tego pola jest pusty string
    BASE_USER_AGENT: '',

    // Alternatywny tekst dla logo
    LOGO_ALT: 'Czysta Polska',

    // Tekst w stopce strony
    FOOTER_TEXT: 'Stowarzyszenie Program Czysta Polska, Al. Stanów Zjednoczonych 61A, 04-028 Warszawa',
};

export default APP_CONFIG;
